'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$uibModalInstance', 'maintenanceKind', 'MaintenanceKindService',
                function($scope, $modalInstance, maintenanceKind, MaintenanceKindService) {
                    MaintenanceKindService.api.get({
                                                       filters: [`'status' EQ 'ENABLED'`],
                                                   }, (data) => $scope.maintenanceKinds = data._embedded);

                    $scope.ok = function() {
                        $modalInstance.close($scope.maintenanceKind[0]);
                    };

                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    };

                    $scope.isSelect = function() {
                        return $scope.maintenanceKind != null;
                    };
                }];
